import './index.erb';
import './index.rb';
import './index.module.scss';
import './images/illustration.svg';

export default class PlannerModal {
  constructor() {
    this.$checkBox = $('#js-planner-modal-checkbox');
    this.bind();
  }

  handleChange() {
    const isChecked = this.$checkBox.prop('checked');
    localStorage.setItem('plannerModalDisabled', !isChecked);
  }

  bind() {
    this.$checkBox.on('change', this.handleChange.bind(this));
  }
}
